export interface LocationInterface {
    name?: string;
    lat: number;
    lon: number;
}

/**
 * @return {Promise<LocationInterface>}
 */
export const getCurrentLocation = (): Promise<LocationInterface> => {
    const startTime = new Date();
    if (navigator.geolocation) {
        return new Promise((resolve, reject) => {
            navigator.geolocation.getCurrentPosition((locationResult) => {
                const duration = (new Date().getTime()) - startTime.getTime();
                if (locationResult?.coords?.latitude !== undefined) {
                    resolve({
                        lat: locationResult.coords.latitude,
                        lon: locationResult.coords.longitude,
                    });
                } else {
                    reject(new Error('We couldn\'t find your current location.'));
                }
            });
        });
    }

    return Promise.reject(new Error('We couldn\'t find your current location.'));
};
